export default{
  setValidationFinalCheck(state,val){
    state.validationFinalCheck = val.finalCheck;
  },
  setValidationFinalResult(state,val){
    state.validationFinalResult = val.finalResult;
  },
  validationReset(state){
    state.validationFinalCheck = false;
    state.validationFinalResult = false;
    state.validationArray = {default:{}};
  },
  setValidationResult(state,val){
    let object = val.object;
    let field = val.field;
    let result = val.result;

    // console.log(val);

    if(!state.validationArray[object]){
      state.validationArray[object] = {};
    }
    if(result == null ){
      delete state.validationArray[object][field]; 
    }else{
    state.validationArray[object][field] = result;  
    }
    // console.log(state.validationArray[object][field]);

},
  setValidationRule(state,val){
    state.validationRules = val.data;
  },

  setAlertMsg(state,val){
    state.alertMsg = val.alertMsg;
  }


}


// WEBPACK FOOTER //
// ./src/Validation/store/mutations.js